module.exports = __webpack_public_path__ + "static/media/MacbookEvents@3x.6589c6e7.png";